import { userHandlers } from '@/mocks/handlers/userHandlers';

import { applicationHandlers } from './applicationHandlers';
import { assetHandlers } from './assetHandlers';
import { billingHandlers } from './billingHandlers';
import { divisionHandlers } from './divisionHandlers';
import { employeeHandlers } from './employeeHandlers';
import { groupHandlers } from './groupHandlers';
import { groupChangeSubResourceHandlers } from './groupChangeSubResourceHandlers';
import { hrisIntegrationHandlers } from './hrisIntegrationHandlers';
import { integrationHandlers } from './integrationHandlers';
import { mdmEnrollmentHandlers } from './mdmEnrollmentHandlers';
import { notificationsHandlers } from './notificationsHandlers';
import { offboardingHandlers } from './offboardingHandlers';
import { onboardingHandlers } from './onboardingHandlers';
import { organizationApplicationChampionHandlers } from './organizationApplicationChampionHandlers';
import { organizationApplicationHandlers } from './organizationApplicationHandlers';
import { organizationHandlers } from './organizationHandlers';
import { packageHandlers } from './packageHandlers';
import { orderHandlers } from './orderHandlers';
import { requestsHandlers } from './requestsHandlers';
import { localhostHandlers } from './localhost';
import { productHandlers } from './productHandlers';
import { secretsHandlers } from './secretsHandlers';
import { scheduledTaskHandlers } from './scheduledTaskHandlers';
import { addOnHandlers } from './addOnHandlers';
import { adminHandlers } from './adminHandlers';
import { conversationHandlers } from './conversationHandlers';
import { deviceHandlers } from './deviceHandlers';
import { employeeBreachHandlers } from './employeeBreachHandlers';
import { thirdPartyHandlers, passthroughHandlers } from './thirdPartyHandlers';
import { googleHandlers } from './googleHandlers';
import { helpfulLinksHandlers } from './helpfulLinksHandlers';
import { internalBillingHandlers } from './internalBillingHandlers';
import { mdmManagementHandlers } from './mdmManagementHandlers';
import { roleHandlers } from './roleHandlers';
import { shipmentHandlers } from './shipmentHandlers';
import { signupHandlers } from './signupHandlers';
import { siteHandlers } from './siteHandlers';
import { webhookHandlers } from './webhookHandlers';

export const handlers = [
  ...userHandlers,
  // Before employeeHandlers/assetHandlers: it answers only the MDM-specific
  // requests and lets everything else fall through to them.
  ...mdmEnrollmentHandlers,
  ...employeeHandlers,
  ...organizationHandlers,
  ...billingHandlers,
  ...divisionHandlers,
  ...groupHandlers,
  ...groupChangeSubResourceHandlers,
  ...applicationHandlers,
  ...assetHandlers,
  ...organizationApplicationHandlers,
  ...organizationApplicationChampionHandlers,
  ...notificationsHandlers,
  ...hrisIntegrationHandlers,
  ...integrationHandlers,
  ...requestsHandlers,
  ...offboardingHandlers,
  ...onboardingHandlers,
  ...packageHandlers,
  ...orderHandlers,
  ...localhostHandlers,
  ...productHandlers,
  ...secretsHandlers,
  ...scheduledTaskHandlers,
  ...addOnHandlers,
  ...adminHandlers,
  ...conversationHandlers,
  ...deviceHandlers,
  ...employeeBreachHandlers,
  ...googleHandlers,
  ...helpfulLinksHandlers,
  ...internalBillingHandlers,
  ...mdmManagementHandlers,
  ...roleHandlers,
  ...shipmentHandlers,
  ...signupHandlers,
  ...siteHandlers,
  ...webhookHandlers,
  ...thirdPartyHandlers,
  // Must be the last: lets third-party assets through to the real network, only if no mock above matched
  ...passthroughHandlers,
];
